import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GlobalService } from '../model/global.service';
import { BodyService } from '../shared/platform/body.service';
import { MetaData } from '../shared/metadata/metadata.service';
import { ObjectUtils } from '../shared/utils/object-utils';
import { AppComponent } from '../app.component';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit, AfterViewInit {

  constructor(
    public globalService: GlobalService,
    public bodyService: BodyService,
    private rootComp: AppComponent,
    private metadata: MetaData,
  ) {
    this.bodyService.resetAndAddClass('home main-at-top');
    console.log('home constructor');
  }

  ngOnInit(): void {
    console.log('home ngoninit');
    this.rootComp.fbService.updateCommonOg();
  }

  ngAfterViewInit(): void {
    if (this.globalService.settings && this.globalService.settings.seo) {
      const seoData = ObjectUtils.copy(this.globalService.settings.seo);

      this.metadata.setTitle('');
      this.metadata.setOg('title', this.metadata.getTitle());

      delete seoData.title;
      delete seoData.meta_title;

      this.metadata.setTextPageMeta(seoData);
    }
  }
}
